import { Grid, Button as MuiButton } from "@mui/material";
import { styled } from "@mui/material/styles";

// export const Button = styled(MuiButton)(({ theme }) => ({
//   minWidth: "40px",

//   svg: {
//     color: theme.palette.primary.contrastText,
//   },

//   "&:hover": {
//     backgroundColor: "rgba(255, 255, 255, .5)",
//   },
// }));

export const Button = styled(MuiButton, {
  shouldForwardProp: (props) => props !== "filterColor",
})<{ filterColor?: string }>(({ filterColor, theme }) => ({
  minWidth: "40px",

  svg: {
    color: filterColor !== "filter" ? theme.palette.primary.contrastText : theme.palette.primary.main,
  },

  "&:hover": {
    backgroundColor: filterColor !== "filter" ? "rgba(255, 255, 255, .5)" : "grey",
  },

  "&:disabled": {
    opacity: "0.4",
  },
}));

export const Container = styled(Grid)({
  display: "flex",
  alignItems: "center",
});
